const fallbackCopyTextToClipboard = (text: string) => {
  const textArea = document.createElement('textarea')

  textArea.value = text
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'
  textArea.style.opacity = '0'
  textArea.style.maxWidth = '0'
  textArea.style.maxHeight = '0'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
  } catch (err) {
    //
  }

  document.body.removeChild(textArea)
}

export const write = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    fallbackCopyTextToClipboard(text)
    return false
  }
}
